var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Sections',{attrs:{"props_search":_vm.props_search,"category_id":_vm.selected_category.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }